module.exports = __webpack_public_path__ + "static/media/stevenson_logo.c6289dcd.png";